const FieldStatus = {
  READONLY: 'readonly',
  EDITABLE: 'editable',
  HIDDEN: 'hidden',
};

export default FieldStatus;
